import { HttpHandlerFn, HttpInterceptorFn, HttpParams, HttpRequest } from '@angular/common/http';
import { ENVIRONMENT } from '../../../../environment/environment';
import { StorageService } from '../../services/storage.service';
import { inject } from '@angular/core';

export const ACCESS_TOKEN_INTERCEPTOR: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const storageService = inject(StorageService);

    let params = new HttpParams({ fromString: req.params.toString() });
    let headers = req.headers;

    // "Is this a backend request?" — handles both modes:
    //  - apiDomain set (e.g. 'https://api.example.com'): match by URL prefix
    //  - apiDomain empty (dev proxy mode): match relative paths under /api/
    // We avoid using indexOf('') which would match every URL and leak the
    // Bearer token to any external host.
    const apiDomain = ENVIRONMENT.apiDomain;
    const isBackendRequest = apiDomain
        ? req.url.indexOf(apiDomain) !== -1
        : req.url.startsWith('/api/');

    if (params.get('noToken')) {
        params = params.delete('noToken');
    } else if (isBackendRequest && storageService.accessToken) {
        headers = headers.set('Authorization', `Bearer ${storageService.accessToken}`);
    }

    // Replay the share-link visitor id the backend handed us on the first
    // visit. The id rides on every backend request so login attribution
    // and post-login dedup can match the row we already inserted, even
    // in cross-site setups where third-party cookies would be blocked.
    if (isBackendRequest && storageService.clipVisitorId) {
        headers = headers.set('X-Visitor-Id', storageService.clipVisitorId);
    }

    req = req.clone({
        params: params,
        headers: headers,
    });

    return next(req);
};
